import { useRef, useEffect } from 'react';
import './Benefits.css';

const benefits = [
  {
    icon: '✓',
    title: 'Исключает подмену',
    description: 'Каждый сотрудник отмечается только своим телефоном. Передать код другому невозможно — система распознает только живой QR на экране.'
  },
  {
    icon: '⚡',
    title: 'Простое внедрение',
    description: 'Один планшет на точку входа. Приложение на телефоны сотрудников. Готово к работе.'
  },
  {
    icon: '🔒',
    title: 'Безопасность данных',
    description: 'Данные хранятся в зашифрованном виде. Доступ по ролям — каждый видит только свои объекты и сотрудников.'
  },
  {
    icon: '📊',
    title: 'Полная история',
    description: 'Поиск по датам, сотрудникам и объектам. Экспорт данных в удобных форматах для дальнейшей обработки.'
  }
];

export default function Benefits() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
          }
        });
      },
      { threshold: 0.1 }
    );

    const items = sectionRef.current?.querySelectorAll('.benefit-item');
    items?.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="benefits" ref={sectionRef} data-scroll-section>
      <div className="container">
        <h2 className="section-title">Основные возможности</h2>
        <p className="section-subtitle">Что умеет система</p>
        
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-item" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="benefit-icon">{benefit.icon}</div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
